import type { AssetTagsResponse, TagType } from '@/types';

/**
 * Tags v2 chip categories — shared by TranscriptPanel's Insights tab (hero)
 * and AssetDetailDrawer (side drawer) so both surfaces always agree on what
 * categories exist. `descriptions` is handled separately by each surface
 * (rendered as prose rows, not chips) and is intentionally not listed here.
 */
export const TAG_CATEGORIES: { label: string; type: TagType; key: keyof AssetTagsResponse['tags'] }[] = [
  { label: 'Objects',    type: 'object',   key: 'objects'    },
  { label: 'Activities', type: 'activity', key: 'activities' },
  { label: 'Scenes',     type: 'scene',    key: 'scenes'     },
  { label: 'Topics',     type: 'topic',    key: 'topics'     },
  { label: 'Locations',  type: 'location', key: 'locations'  },
  { label: 'People',     type: 'person',   key: 'people'     },
];
